import { render, staticRenderFns } from "./orderContinue.vue?vue&type=template&id=2df1506c&scoped=true&"
import script from "./orderContinue.vue?vue&type=script&lang=js&"
export * from "./orderContinue.vue?vue&type=script&lang=js&"
import style0 from "./orderContinue.vue?vue&type=style&index=0&id=2df1506c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df1506c",
  null
  
)

export default component.exports